import { Input } from 'shared/components/ui/Input';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepArenaInfo(state: ArenaOnboardingState) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-ink-secondary">
        Comece com os dados da sua arena e da primeira unidade. Você poderá adicionar outras
        unidades depois.
      </p>
      <Input
        label="Nome da arena"
        name="arenaName"
        placeholder="Ex.: Arena Praia Norte"
        value={state.arenaName}
        onChange={(event) => state.setArenaName(event.target.value)}
      />
      <Input
        label="Nome da unidade"
        name="unitName"
        value={state.unitName}
        onChange={(event) => state.setUnitName(event.target.value)}
      />
      <Input
        label="Endereço"
        name="address"
        placeholder="Rua, número - bairro"
        value={state.address}
        onChange={(event) => state.setAddress(event.target.value)}
      />
      <Input
        label="Cidade"
        name="city"
        value={state.city}
        onChange={(event) => state.setCity(event.target.value)}
      />
    </div>
  );
}
